import posthog from 'posthog-js';

export const initPostHog = () => {
  const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
  const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

  if (posthogKey && posthogHost) {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      // Capture pageviews automatically
      capture_pageview: true,
      // Capture performance metrics
      capture_pageleave: true,
      // Enable session recording (optional - you can disable this)
      session_recording: {
        recordCrossOriginIframes: true,
      },
    });
  } else {
    console.warn('PostHog environment variables are not set');
  }
};

export default posthog;
